import * as React from 'react';
import SVGInline from 'react-svg-inline';
import { Follow } from 'react-twitter-widgets';

import TwitterFeed from '../../../containers/HomePage/TwitterFeed/TwitterFeed';

import { TwitterLocale } from './twitter.locale';
import styles from './Twitter.scss';

import megaPhoneIcon from '../../Icon/megaphone.svg';
import blob from '../../Icon/twitter-blob.svg';
import Blob from '../../Blob/Blob';

interface TwitterProps {
  locale: TwitterLocale;
}

const Twitter: React.SFC<TwitterProps> = ({ locale }) => (
  <section className={styles.section}>
    <div className="container">
      <Blob image={blob} top="0px" />
      <div className="row justify-content-between">
        <div className="col-12 col-md-6 col-lg-5 d-flex flex-column justify-content-center">
          <h2 style={styles.title} className="mb-3">
            {locale.title}
          </h2>
          <Follow username="Peering_cz" options={{ size: 'large', showCount: false }} />

          <div className={styles.announcement}>
            <strong className={styles.announcementTitle}>
              <SVGInline svg={megaPhoneIcon} className={styles.icon} />
              {locale.announcementTitle}
            </strong>
            <p
              className={styles.announcementText}
              dangerouslySetInnerHTML={{ __html: locale.announcementText }}
            />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <TwitterFeed />
        </div>
      </div>
    </div>
  </section>
);

export default Twitter;



// WEBPACK FOOTER //
// /www/client/src/components/HomePage/Twitter/Twitter.tsx